if (!window.Eurus.loadedScript.includes('coupon-code.js')) {
  window.Eurus.loadedScript.push('coupon-code.js');
  
  requestAnimationFrame(() => {
    document.addEventListener("alpine:init", () => {
      Alpine.data("xCounponCode", () => ({
        coppySuccess: false,
        copyCode() {
          if (this.coppySuccess) return;

          const discountCode = this.$refs.code_value.textContent.trim();
          navigator.clipboard.writeText(discountCode).then(
            () => {
              this.coppySuccess = true;

              setTimeout(() => {
                this.coppySuccess = false;
              }, 5000);
            },
            () => {
              alert('Copy fail');
            }
          );
        },
        clearCouponCode() {
          let cookieValue = document.cookie.match('(^|;)\\s*' + 'eurus_discount_code' + '\\s*=\\s*([^;]+)');
          let appliedDiscountCodes = cookieValue ? cookieValue.pop().split(",") : '';
           console.log(JSON.stringify(appliedDiscountCodes));
          if(JSON.stringify(appliedDiscountCodes) != '["none"]') {
            document.cookie = `eurus_discount_code=none; path=/`;
          }
        },
        applyCouponCode(discountCodes) {
          let cookieValue = document.cookie.match('(^|;)\\s*' + 'eurus_discount_code' + '\\s*=\\s*([^;]+)');
          let appliedDiscountCodes = cookieValue ? cookieValue.pop().split(",") : '';
          if(JSON.stringify(appliedDiscountCodes) == discountCodes) {
            return;
          }
          console.log(discountCodes);
          discountCodes = JSON.parse(discountCodes);
          document.cookie = `eurus_discount_code=${discountCodes}; path=/`;
          fetch(`/checkout?discount=${discountCodes}`)
          .then(() => {
            fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                "sections":  Alpine.store('xCartHelper').getSectionsToRender().map((section) => section.id)
              }),
            }).then(response=>{
              return response.json();
            }).then((response) => {
              if (response.status != '422') {
                Alpine.store('xCartHelper').getSectionsToRender().forEach((section => {
                  const sectionElement = document.querySelector(section.selector);
                  if (sectionElement) {
                    if (response.sections[section.id])
                      sectionElement.innerHTML = getSectionInnerHTML(response.sections[section.id], section.selector);
                  }
                }));
              }
            }).finally(() => {
              this.loading = false;
            });
          })
          .catch(function(error) {
            console.error('Error:', error);
          })
        },
      }));
    });
  });
}